
import Vue from "vue";

export default Vue.extend({
  name: "AdminDataTable",
  props: {
    headers: { type: Array, required: true },
    items: { type: Array, required: true },
    loading: { type: Boolean, default: false },
    search: { type: String, default: "" },
    placeholder: { type: String, required: true }
  }
});
